// This file was automatically generated from uiwidget.NewActionsMenu.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.NewActionsMenu');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.NewActionsMenu.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div', (opt_data.menuId) ? ' id="' + soy.$$escapeHtml(opt_data.menuId) + '"' : '', ' class="am-container el8ActionsMenuDialog"><ul class="am-list el8ActionsMenuList ebs-list-unstyled"></ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.NewActionsMenu.contentTwoColumn = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div', (opt_data.menuId) ? ' id="' + soy.$$escapeHtml(opt_data.menuId) + '"' : '', ' class="am-container el8ActionsMenuDialog"><ul class="am-list-left el8ActionsMenuList el8ActionsMenuListLeftColumn ebs-list-unstyled"></ul><ul class="am-list-right el8ActionsMenuList el8ActionsMenuListRightColumn ebs-list-unstyled"></ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.NewActionsMenu.action = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.a.type == 'heading') ? '<li class="el8Header">' + soy.$$escapeHtml(opt_data.a.actionText) + '</li>' : (opt_data.a.type == 'line') ? '<hr class="el8Dashed">' : (opt_data.a.actionText) ? '<li actionIndex="' + soy.$$escapeHtml(opt_data.index) + '" class="' + ((opt_data.a.indent) ? 'el8Indent ' : '') + ((opt_data.a.type == 'remove') ? 'el8RemoveItem ' : '') + '">' + soy.$$escapeHtml(opt_data.a.actionText) + '</li>' : (opt_data.a.actionSafeText) ? '<li actionIndex="' + soy.$$escapeHtml(opt_data.index) + '" class="' + ((opt_data.a.indent) ? 'el8Indent ' : '') + ((opt_data.a.type == 'remove') ? 'el8RemoveItem ' : '') + '">' + opt_data.a.actionSafeText + '</li>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.NewActionsMenu.actions = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var aList840 = opt_data.actionsList;
  var aListLen840 = aList840.length;
  for (var aIndex840 = 0; aIndex840 < aListLen840; aIndex840++) {
    var aData840 = aList840[aIndex840];
    if (opt_data.right && aData840.right) {
      el8.template.uiwidget.NewActionsMenu.action({a: aData840, index: aIndex840}, output);
    } else if (! opt_data.right && ! aData840.right) {
      el8.template.uiwidget.NewActionsMenu.action({a: aData840, index: aIndex840}, output);
    }
  }
  if (!opt_sb) return output.toString();
};
